import {EEditableCellMaskValidation} from 'components/editable-table/lib/editable-cell-validation';
import {IFieldMeta} from 'entities/metadata';


interface IRequestValidationField {
    fieldKey: string;
    referenceUrl: string;
}

/**
 * Возвращает поля с маской "requestValidation" из метаданных
 *
 * @param fieldsMeta - Массив метаданных полей для анализа
 * @returns Массив IRequestValidationField[] для валидации запросом
 *
 */
export const getRequestValidationFields = (fieldsMeta: IFieldMeta[]): (IRequestValidationField)[] =>
    fieldsMeta.reduce<IRequestValidationField[]>((acc, field) => {
        const requestValidationRule = field.validationRules?.find(
            rule => rule.mask === EEditableCellMaskValidation.requestValidation
        );

        if (requestValidationRule?.referenceUrl) {
            acc.push({
                fieldKey: field.key,
                referenceUrl: requestValidationRule.referenceUrl,
            });
        }

        return acc;
    }, []);